import { ArticleItemProps as Article } from './Article';

export const enum CollectionStatus {
  PUBLIC = 'public',
  PRIVATE = 'private',
  DELETED = 'deleted',
}

export interface Collection {
  id: number;
  title: string;
  isFixed: boolean;
  likeCount: number;
  viewCount: number;
  isPublic: boolean;
  isLiked: boolean;
  description: string;
  dateLastOpen: string;
  scrappedCount: number;
  thumbnail: string | null;
  thumbnailMainColor: string;
  dateDeleted: string | null;
  isCollectionScrapped: boolean;
  profile: {
    id: number;
    image: string;
    name: string;
    role: string;
    roleKor: string;
  };
  scraps: {
    id: number;
    news: Article;
    profile: number;
    dateCreated: string;
    dateModified: string;
    externalContent: ExternalContent;
  }[];
  hashTags: {
    id: number;
    name: string;
    slug: string;
    totalUses: number;
    collectionUses: number;
  }[];
}

export interface CollectionList {
  id: number;
  title: string;
  scraps: number[];
  likeCount: number;
  viewCount: number;
  scrappedCount: number;
  thumbnail: string;
  thumbnailMainColor: string;
  isPublic: boolean;
  isFixed?: boolean;
  profile: {
    id: number;
    image: string;
    name: string;
    role: string;
    roleKor: string;
  };
}

export interface ExternalContent {
  url: string;
  title: string;
  image: string;
  description: string;
}

export interface CollectionTag {
  tag: string;
  name: string;
  filter: string[];
  isSelected?: boolean;
}

export interface CollectionListData {
  maxPage: number;
  list: Collection[];
  totalCount: number;
}
